import React, { useState } from "react";
import { Box, Input } from "@chakra-ui/react";
import { FaSearch } from "react-icons/fa";

export function SearchInput(props) {
  const [onFocused, setOnFocused] = useState(false);

  return (
    <Box
      w="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderColor="#BCC0CC"
      borderWidth="1px"
      borderRadius="8px"
      height="2.6rem"
      background="white"
      opacity={onFocused ? "1" : "0.8"}
    >
      <FaSearch color="#70747D" size={18} style={{ marginLeft: 16 }} />

      <Input
        w="100%"
        flex={1}
        border="0px"
        height="2.4rem"
        borderRadius="8px"
        paddingX="0.5rem"
        color="#70747D"
        fontSize="sm"
        _focus={[{ border: "0px" }]}
        onBlurCapture={() => setOnFocused(false)}
        onFocusCapture={() => setOnFocused(true)}
        {...props}
      />
    </Box>
  );
}
